<div class="!hidden gt-sm:!flex gt-sm:flex-col justify-end items-{{ alignNumbers }}">
  <ng-container *ngFor="let part of barParts; let last = last">
    <p class="value-wrapper" *ngIf="part | featureLike: 'value':'unit' as featureLike">
      <span>
        {{ featureLike | value2: featurePropertyKey.value:'':'1.0-2' }}
      </span>

      <span>
        {{ featureLike | unit: featurePropertyKey.value }}
      </span>
    </p>
    <hr *ngIf="!last" />
  </ng-container>
</div>
